import { z } from 'zod';

export const revenueExpenseReportSchema = z.object({});

export type EditPrintTemplateTableType = object;

export const editPrintTemPlateSchema = z.object({});

export type EditPrintTemplateFormValues = z.infer<typeof editPrintTemPlateSchema>;

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  reportTemplate: z.number().optional(),
  xtype: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const searchInitialValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  reportTemplate: 0,
  xtype: 'pending_issuance'
};
